export function downloadFile(fileData: string | Blob, fileName: string, fileType: string = 'application/octet-stream;charset=utf-8') {
    if (fileData) {
        var blob = typeof fileData === 'string' ? new Blob([s2ab(atob(fileData))], { type: fileType }) : fileData;

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, fileName);
        }
        else {
            var a = document.createElement('a');
            var url = window.URL.createObjectURL(blob);

            a.href = url;
            a.download = fileName;
            a.hidden = true;

            document.body.appendChild(a);

            a.click();

            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }
}

function s2ab(str: string) {
    var buffer = new ArrayBuffer(str.length);
    var view = new Uint8Array(buffer);

    var length = str.length;
    for (var i = 0; i < length; ++i) {
        view[i] = str.charCodeAt(i);
    }

    return buffer;
}



// WEBPACK FOOTER //
// ./src/utils/DownloadUtil.ts